!function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}p||((p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",p.onerror=function(){p=null},(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r));var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],Object.defineProperty(u,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e}}),Object.defineProperty(u.people,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(){return u.toString(1)+".people (stub)"}}),o="init capture register register_once register_for_session unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group identify setPersonProperties setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags resetGroups onFeatureFlags addFeatureFlagsHandler onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);

// PostHog ne démarre qu'après acceptation des cookies (bandeau Sirdata, API TCF).
// Avant : aucun script PostHog chargé, aucun cookie, aucun événement.
// Après : init normal, qui relit le cookie existant et garde le même visiteur de page en page.
// v2 (09/10/2026) : Product Viewed est envoyé par le thème, en même temps que la page vue.
// Le pixel Shopify le perdait dans les navigateurs intégrés de Facebook et Instagram.
(function () {
  var started = false;

  function productName(variant) {
    var name = variant.name || '';
    var suffix = variant.public_title ? ' - ' + variant.public_title : '';
    return suffix && name.slice(-suffix.length) === suffix ? name.slice(0, -suffix.length) : name;
  }

  function trackProductView() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var product = meta && meta.product;
    if (!product || !product.variants || !product.variants.length) return;
    var variant = product.variants[0];
    posthog.capture('Product Viewed', {
      source: 'theme',
      product_id: String(product.id),
      variant_id: String(variant.id),
      name: productName(variant),
      variant: variant.public_title || undefined,
      sku: variant.sku || undefined,
      category: product.type || undefined,
      handle: product.handle,
      price: typeof variant.price === 'number' ? variant.price / 100 : undefined,
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
    });
  }

  function start() {
    if (started) return;
    started = true;
    posthog.init('phc_q2uLsPSEejujtVyAhAAGY9UBgmRmYjQWBjvxGTiyNg6Y', {
      api_host: 'https://eu.i.posthog.com',
      defaults: '2026-05-30'
    });
    trackProductView();
  }

  function check(tcData, ok) {
    if (!ok || !tcData) return;
    if (tcData.eventStatus !== 'tcloaded' && tcData.eventStatus !== 'useractioncomplete') return;
    if (tcData.purpose && tcData.purpose.consents && tcData.purpose.consents[1]) start();
  }

  function listen(tries) {
    if (typeof window.__tcfapi === 'function') {
      window.__tcfapi('addEventListener', 2, check);
    } else if (tries < 50) {
      setTimeout(function () { listen(tries + 1); }, 200);
    }
  }

  listen(0);
})();
